module.exports = __webpack_public_path__ + "media/images/childcare/patricia-37f7077f1811e33e9fbaa66f308f7dd6.jpg";